import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getMotoristaEmpresa,
    getGestorOperacoes,
    getOperadorEmpresa,
    getPerfisVendedores,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import selecionarRota from '../../actions/rota/selecionarRota';
import limparItinerarios from '../../actions/itinerario/limparItinerarios'

export class MenuFechamentoCaixa extends Component {

    componentDidMount() {
        this.props.selecionarRota([])
        this.props.limparItinerarios();
    }

    render() {
        const id = this.props.empresaSelecionada.id;
        return (
            <div className="container-padrao">
                <Titulo texto="Itinerários" urlRetorno="/"/>
                <div className="vx-menu-grid">
                    <Autorizacao
                        perfisPermitidos={[PERFIL_ADMIN, getOperadorEmpresa(id), getGestorOperacoes(id), getAdminEmpresa(id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <Link to="/painel-prestadores" className="vx-menu-card">
                            <div className="vx-menu-card-icon">
                                <i className="material-icons">assignment_ind</i>
                            </div>
                            <span className="vx-menu-card-label">Prestadores Empresa</span>
                        </Link>
                    </Autorizacao>

                    <Autorizacao
                        perfisPermitidos={[PERFIL_ADMIN, getGestorEmpresa(id), getGestorOperacoes(id), getOperadorEmpresa(id), ...getPerfisVendedores(id), getFiscalEmbarque(id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <Link to="/painel-itinerarios" className="vx-menu-card">
                            <div className="vx-menu-card-icon">
                                <i className="material-icons">date_range</i>
                            </div>
                            <span className="vx-menu-card-label">Gerenciar Itinerários</span>
                        </Link>
                    </Autorizacao>

                    <Autorizacao
                        perfisPermitidos={[getOperadorEmpresa(id), getMotoristaEmpresa(id), getGestorEmpresa(id), getGestorOperacoes(id), getAdminEmpresa(id), getFiscalEmbarque(id), PERFIL_ADMIN]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <Link to="/painel-embarque-passageiros" className="vx-menu-card">
                            <div className="vx-menu-card-icon">
                                <i className="material-icons">transfer_within_a_station</i>
                            </div>
                            <span className="vx-menu-card-label">Embarque de Passageiros</span>
                        </Link>
                    </Autorizacao>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        authentication: state.authentication
    }
}

export default withRouter(connect(mapStateToProps, {
    selecionarRota,
    limparItinerarios
})(MenuFechamentoCaixa));
